module.exports = __webpack_public_path__ + "static/img/1.c7f61c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/1.png
// module id = wiKy
// module chunks = 0